import { FC } from 'react';

import { PlansSection, PropertyDataSection } from './components';
import { TableFeatures } from './components/TableFeatures';

interface ChildrenTabConsortiumProps {
  duplicateId?: number;
  id: number;
}

export const ChildrenTabConsortium: FC<ChildrenTabConsortiumProps> = ({
  duplicateId,
  id,
}) => {

  return (
    <div className='mt-1'>
      <PlansSection id={id} duplicateId={duplicateId} />

      <PropertyDataSection id={id} duplicateId={duplicateId} />
      {/* <TableFeatures id={id} duplicateId={duplicateId}  /> Se comenta momentaneamente en master */}
    </div>
  );
};
